module.exports = __webpack_public_path__ + "img/decosummit-logo.fd66a35f.webp";